import client from './axiosInstance';

export const fetchHolidaysFilterList = async () => {
  return await client.get(`/holidays/base/holidays`);
};
